export default __webpack_public_path__ + "static/media/MERN_app_template.6ed06d15.jpeg";